import * as React from 'react';
import clsx from 'clsx';
import { useBox } from '../Box';
import { useFlex } from '../Flex';
import { useText } from '../Text';
function Base({
  tagName = 'div',
  children,
  refCallback,
  innerRef,
  className,
  ...extraProps
}) {
  const [boxClasses, boxExtra] = useBox(extraProps);
  const [flexClasses, flexExtra] = useFlex(boxExtra);
  const [textClasses, textExtra] = useText(flexExtra);
  return /*#__PURE__*/React.createElement(tagName, {
    ref: innerRef || refCallback,
    className: clsx(boxClasses, flexClasses, textClasses, className),
    ...textExtra
  }, children);
}
export { Base };